import React, { useRef, useEffect, useState } from 'react';
import AboutBanner from '../../components/AboutBanner';
import HeaderSection from '../../components/HeaderSection';
import Navbar from '../../components/Navbar';
import AboutPersonalized from '../../components/AboutPersonalized';
import Team from '../../components/Team';
import AboutNutritionSection from '../../components/AboutNutritionSection';
import Footer from '../../components/Footer';
import Founder from '../../components/Founder';
import AboutJourney from '../../components/AboutJourney';
import AboutBenefit from '../../components/AboutBenefit';
import Timeline from '../../components/TimeLine';
import { getSeoByUrl } from '../../api/api';
import { Helmet } from "react-helmet-async";

const AboutUS = () => {
  const appointmentRef = useRef(null);
  const [seoData, setSeoData] = useState({});

  const scrollToAppointment = () => {
    if (appointmentRef.current) {
      appointmentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const response = await getSeoByUrl("about-us");

        if (response.success && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error("Error fetching SEO data:", error);
      }
    };

    fetchSeoData();
  }, []);

  return (
    <div>
      <Helmet>
        {/* ================= PRIMARY META ================= */}
        <title>{seoData.metaTitle || "About Us | Nutrillion"}</title>

        <meta
          name="description"
          content={
            seoData.metaDescription ||
            "Learn about Nutrillion and our personalized nutrition mission."
          }
        />

        {seoData.metaKeywords && (
          <meta name="keywords" content={seoData.metaKeywords} />
        )}

        <meta
          name="robots"
          content={seoData.robotsTxt || "index, follow"}
        />

        <link
          rel="canonical"
          href={
            seoData.canonicalUrl ||
            "https://nutrillion.one/about-us"
          }
        />

        {/* ================= OPEN GRAPH ================= */}
        <meta property="og:type" content={seoData.ogType || "website"} />
        <meta property="og:title" content={seoData.ogTitle || seoData.metaTitle || "About Us | Nutrillion"} />
        <meta property="og:description" content={seoData.ogDescription || seoData.metaDescription || "Learn about Nutrillion and our personalized nutrition mission."} />
        <meta property="og:url" content={seoData.ogUrl || seoData.canonicalUrl || "https://nutrillion.one/about-us"} />
        {seoData.ogImage && (
          <meta property="og:image" content={seoData.ogImage} />
        )}
        <meta property="og:site_name" content="Nutrillion" />

        {/* ================= TWITTER CARD ================= */}
        <meta name="twitter:card" content={seoData.twitterCard || "summary"} />
        <meta name="twitter:title" content={seoData.twitterTitle || seoData.metaTitle || "About Us | Nutrillion"} />
        <meta name="twitter:description" content={seoData.twitterDescription || seoData.metaDescription || "Learn about Nutrillion and our personalized nutrition mission."} />
        {(seoData.twitterImage || seoData.ogImage) && (
          <meta name="twitter:image" content={seoData.twitterImage || seoData.ogImage} />
        )}

       {seoData.schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(
              typeof seoData.schemaMarkup === "string"
                ? JSON.parse(seoData.schemaMarkup)
                : seoData.schemaMarkup
            )}
          </script>
        )}
      </Helmet>

      <AboutBanner />
      <Timeline />
      <AboutPersonalized />
      <Team />
      <AboutNutritionSection />
      <AboutJourney />
      <AboutBenefit />
      <Founder />
    </div>
  );
};

export default AboutUS;